import { Tag, Typography } from 'antd';
import { UserAvatar } from '@/components/UserAvatar/UserAvatar';
import { IChatEntity } from '@/shared/interfaces/chat-entity.interface';
import { formDate } from '@/services/utils/formatDate';
import '../HistoryIcon/HistoryIcon.scss';

const { Text } = Typography;

interface IChatEntityProps {
  chatEntity: IChatEntity;
  isPrevious?: boolean;
}

export const ChatEntity = ({ chatEntity, isPrevious }: IChatEntityProps) => {
  const {
    user: { fullName },
    createdTimestamp,
    channelProvider,
    externalCustomerIdentity,
  } = chatEntity;
  const [firstName = '', lastName = ''] = fullName ? fullName.split(' ') : ' ';

  const parsedPhoneNumber = (identity: string | undefined): string => {
    if (!identity) {
      return '';
    }
    return identity.replace(/\D/g, '');
  };

  const renderDate = () => {
    if (!createdTimestamp) {
      return;
    }

    return (
      <div className="text-right user-item-date">
        <div>{formDate(createdTimestamp)}</div>
      </div>
    );
  };

  return (
    <div className="history-icon">
      <UserAvatar
        className={'custom-avatar'}
        avatar={channelProvider}
        firstName={firstName}
        lastName={lastName}
        size={40}
      />
      <div className="history-icon__info">
        <div className="history-icon__name">
          <div className="history-icon__name-details">
            <Text ellipsis={{ tooltip: fullName }} className="full-name">
              {fullName}
            </Text>
          </div>

          {externalCustomerIdentity && (
            <div className="history-icon__phone-details">
              <Text className="phone">
                {parsedPhoneNumber(externalCustomerIdentity)}
              </Text>
              {isPrevious && (
                <Tag
                  style={{ marginTop: '0' }}
                  className="history-icon__name-tag last-selected"
                >
                  Last
                </Tag>
              )}
            </div>
          )}
        </div>
        <div className="back-text">{renderDate()}</div>
      </div>
    </div>
  );
};
